import {db} from '../firebase'
import Vue from 'vue'
import router from '../router'
import store from '../store'

export default {
    namespaced: true,
    state: {
        books: [],
        currentBook: [],
        filters:{
            categories:[],
            tags:[]
        }
    },
    mutations: {
        setBooks(state, books){
            state.books = books
        },
        setCurrentBook(state, book){
            state.currentBook = book
        },
        setSelectedCategories(state, categories){
            state.filters.categories = categories
        },
        setSelectedTags(state, tags){
            state.filters.tags = tags
        }
    },
    actions: {
        doPublish({rootState}, {id, title, thumbnail, description, categories, tags, pdf}){
            try{
                const bookRef = db.collection('books').doc(id)
                bookRef.set({
                    title,
                    thumbnail,
                    createdAt: Date.now(),
                    bookId: id,
                    userId: rootState.user.user.uid,
                    categories,
                    tags
                })
                bookRef.collection('data').doc('single').set({
                    title,
                    thumbnail,
                    createdAt: Date.now(),
                    description,
                    categories,
                    pdf,
                    tags
                })
                Vue.$toast.success('El libro fue subido')
                router.push({name: 'Dashboard'})
            }catch(error){
                Vue.$toast.error('Hubo un problema al subir el libro, intenta nuevamente más tarde')
                console.error(error)
            }
        },
        getBookId(){
            return db.collection('books').doc().id
        },
        async getBooks({commit}, limit){
            const booksRef = await db.collection('books').orderBy('createdAt', 'desc').limit(limit).get()
            var books = []
            booksRef.forEach((book)=>{
                books.push(book.data())
            })
            commit('setBooks', books)
        },
        async getBook({commit}, {title, createdAt}){
            createdAt = parseInt(createdAt, 10)
            const bookRef = await db.collection('books').where('title', '==', title).where('createdAt', '==', createdAt).get()
            if(!bookRef.empty){
                const book = await db.collection('books').doc(bookRef.docs[0].id).collection('data').doc('single').get()
                commit('setCurrentBook', book.data())
            }else{
                router.push({name: 'Home'})
            }
        },
        async getBookById({commit}, id){
            const book = await db.collection('books').doc(id).collection('data').doc('single').get()
            if(book.exists){
                commit('setCurrentBook', book.data())
                return book.data()
            }else{
                router.push({name: 'PublishBook'})
            }
        },
        doUpdate(context, {id, title, thumbnail, description, categories, tags, pdf}){
            try{
                const bookRef = db.collection('books').doc(id)
                bookRef.update({
                    title,
                    thumbnail,
                    categories,
                    tags
                })
                bookRef.collection('data').doc('single').update({
                    title,
                    thumbnail,
                    description,
                    categories,
                    tags,
                    pdf
                })
                Vue.$toast.success('El libro fue editado')
                router.push({name: 'Dashboard'})
            }catch(error){
                Vue.$toast.error('Hubo un problema al editar el libro, intenta nuevamente más tarde')
                console.error(error)
            }
        },
        async doDelete({dispatch}, id){
            const bookRef = db.collection('books').doc(id)
            const book = await bookRef.collection('data').doc('single').get()  
            const bookData = book.data()
            if(bookData.pdf){
                store.dispatch('utils/deleteFileFromUrl', bookData.pdf)
            }
            store.dispatch('utils/deleteFileFromUrl', bookData.thumbnail)

            bookRef.collection('data').doc('single').delete()
            bookRef.delete()
            dispatch('getBooks', Infinity)
        }
    },
}